import {schema} from 'normalizr'
import {articleSchema} from './article'
import {pollSchema} from './poll'
import {postSchema} from './post'
import {askSchema} from "./ask";
import {musicSchema} from "../music";
import {codiDocumentSchema} from "./document";

export const bookmarkSchema = new schema.Entity(
    'bookmarks',
    {
        owner: new schema.Union(
            {
                post: postSchema,
                ask: askSchema,
                poll_question: pollSchema,
                article: articleSchema,
                music: musicSchema,
                codi_document: codiDocumentSchema
            },
            '_type'
        )
    },
    {
        idAttribute: 'id'
    }
)


export const folderSchema = new schema.Entity(
    'folders',
    {},
    {
        idAttribute: 'id'
    }
)
